import vmClient from '../../services/vmClient';
import pick from 'lodash/pick';
import { Entity, IEntityType, IEntity } from './../../types/entity';
import { IUser, userAttributes, userAssociations } from './User';

export interface IUserDetail extends IEntity {
  attributes: Pick<
      IUser['attributes'],
      'id' | 'displayName' | 'language' | 'profileCompleted' | 'confirmed' | 'image' | 'abilities'
    > & {
    maskedEmail: string | null;
    maskedName: string | null;
    maskedSkypeId: string | null;
  };
  associations: Pick<IUser['associations'], 'staffMember' | 'teacher' | 'brand'>;
}

export type UserDetail = Entity<IUserDetail>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserDetail: IEntityType<IUserDetail> = vmClient.defineClass({
  typeName: 'UserDetail',
  version: 2,
  persisted: true,
  attributes: {
    ...pick(
      userAttributes,
      ['id', 'displayName', 'language', 'profileCompleted', 'confirmed', 'image', 'abilities'],
    ),

    maskedEmail:                   'string',
    maskedName:                    'string',
    maskedSkypeId:                 'string',
  },
  associations: pick(userAssociations, ['staffMember', 'teacher', 'brand']),
});

export default UserDetail;
